export const formatSize = (value) => {
  if (!value) return undefined;
  if (typeof value === 'string') return value;
  return `${value}px`;
};

export const getSelectionStyle = (isSelected, isHovered, enabled) => {
  if (!enabled) return {};
  
  if (isSelected) {
    return {
      outline: '1px dashed #2196f3',
      outlineOffset: '2px'
    };
  }
  if (isHovered) {
    return {
      outline: '1px dashed #ff9800',
      outlineOffset: '1px'
    };
  }
  return {};
};

export const getPositionStyle = ({ position, lockedEdges, top, left, right, bottom, unit }) => {
  if (position === 'absolute' || position === 'relative') {
    const positionStyle = { position };
    
    if (lockedEdges.top && top !== undefined) {
      positionStyle.top = `${top}${unit}`;
    }
    if (lockedEdges.left && left !== undefined) {
      positionStyle.left = `${left}${unit}`;
    }
    if (lockedEdges.right && right !== undefined) {
      positionStyle.right = `${right}${unit}`;
    }
    if (lockedEdges.bottom && bottom !== undefined) {
      positionStyle.bottom = `${bottom}${unit}`;
    }
    
    return positionStyle;
  }
  return { position };
};

export const buildContainerStyle = ({
  width, maxWidth, minWidth, flex, flexGrow, flexShrink, flexBasis,
  backgroundColor, borderRadius, padding, position, lockedEdges,
  top, left, right, bottom, unit, style = {}
}) => ({
  transition: 'all 0.2s ease',
  width: formatSize(width),
  maxWidth: formatSize(maxWidth),
  minWidth: formatSize(minWidth),
  flex: flex,
  flexGrow: flexGrow,
  flexShrink: flexShrink,
  flexBasis: flexBasis,
  boxSizing: 'border-box',
  backgroundColor: backgroundColor,
  borderRadius: borderRadius ? `${borderRadius}px` : undefined,
  padding: padding ? `${padding}px` : undefined,
  ...getPositionStyle({ position, lockedEdges, top, left, right, bottom, unit }),
  ...style
});

export const buildLabelStyle = ({ labelFontSize, fontFamily, labelBold, labelItalic }) => ({
  display: 'block',
  fontSize: `${labelFontSize}px`,
  fontFamily: fontFamily,
  fontWeight: labelBold ? 'bold' : 'normal',
  fontStyle: labelItalic ? 'italic' : 'normal',
  marginBottom: '4px',
  color: '#333'
});